import styled from 'styled-components';
import { Button } from 'components/Button';

export const LinkButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
`;
